import { darken } from "polished";

import { PreferenceThemeColorsEnum, PreferenceThemeSlugsEnum } from "@_types/preferences/Preference.enums";

import { getContrastColor } from ".";

interface ColorsMap {
  [color: string]: string;
}

export function setCSSColors({ primary, hover, pressed, contrast }: ColorsMap) {
  document.documentElement.style.setProperty("--primary-color-theme", primary);
  document.documentElement.style.setProperty("--plyr-color-main", primary);
  document.documentElement.style.setProperty("--hover-color-theme", hover);
  document.documentElement.style.setProperty("--pressed-color-theme", pressed);
  document.documentElement.style.setProperty("--contrast-color-theme", contrast);
  document.documentElement.style.setProperty("--scrollbar-color-theme", primary);
}

export function setThemeInCSS(customized: boolean, themeSlug: PreferenceThemeSlugsEnum, color: string) {
  let primary = "#0D6EDE";
  let pressed = "#4dc6ff";
  let contrast = "#f5f5f6";
  let hover = "#19b6ff";

  if (customized) {
    primary = color;
    contrast = getContrastColor(color);
    hover = darken(0.1, color);
    pressed = darken(0.2, color);
  } else {
    primary = ThemeStyles[themeSlug].primary;
    contrast = ThemeStyles[themeSlug].contrast;
    hover = ThemeStyles[themeSlug].hover;
    pressed = ThemeStyles[themeSlug].pressed;
  }

  setCSSColors({ primary, hover, pressed, contrast });
}

const ThemeStyles = {
  [PreferenceThemeSlugsEnum.CLEAN]: {
    primary: PreferenceThemeColorsEnum.CLEAN,
    hover: "#3390FA",
    pressed: "#052B57",
    contrast: "#E6E7EA",
  },
  [PreferenceThemeSlugsEnum.HEART]: {
    primary: PreferenceThemeColorsEnum.HEART,
    hover: "#DF4971",
    pressed: "#DA2B59",
    contrast: "#171717",
  },
  [PreferenceThemeSlugsEnum.MAGIC]: {
    primary: PreferenceThemeColorsEnum.MAGIC,
    hover: "#AE63E3",
    pressed: "#9E43DF",
    contrast: "#171717",
  },
  [PreferenceThemeSlugsEnum.SUN]: {
    primary: PreferenceThemeColorsEnum.SUN,
    hover: "#F5D400",
    pressed: "#EBCB00",
    contrast: "#171717",
  },
  [PreferenceThemeSlugsEnum.OCEAN]: {
    primary: PreferenceThemeColorsEnum.OCEAN,
    hover: "#084387",
    pressed: "#052B57",
    contrast: "#171717",
  },
  [PreferenceThemeSlugsEnum.MARS]: {
    primary: PreferenceThemeColorsEnum.MARS,
    hover: "#F59D05",
    pressed: "#F59D05",
    contrast: "#171717",
  },
  [PreferenceThemeSlugsEnum.MINT]: {
    primary: PreferenceThemeColorsEnum.MINT,
    hover: "#21BA78",
    pressed: "#1DA56C",
    contrast: "#171717",
  },
};
